import Cookies from 'universal-cookie'

const cookies = new Cookies()

const getExpiration = (date, days, minutes) => {
  if (!days && !minutes) {
    return ''
  }

  const result = new Date(date)
  if (days) result.setDate(result.getDate() + days)
  if (minutes) result.setTime(result.getTime() + minutes * 60000)
  return result
}

const set = (name, value, days, minutes, nPath, nDomain, sameSite = 'lax', secure = 'true') => {
  const expires = getExpiration(Date.now(), days, minutes)
  const path = nPath || '/'
  const domain = process.env.BUILD_STAGE !== 'develop' ? nDomain : undefined

  try {
    cookies.set(name, value, { expires, path, domain, sameSite, secure })
  } catch (e) {
    console.log('cookie error', e)
  }
}

const get = name => cookies.get(name)

const remove = (name, path, domain) => {
  try {
    cookies.remove(name, { path, domain })
  } catch (e) {
    console.log('remove cookie error', e)
  }
}

export default {
  set,
  get,
  remove
}
